import * as TextStylingService from 'src/services/text-styling';

import AbstractElement from './abstractElement';

import { isSafari } from 'src/utils/safari';
import { PartialStylingAttributes } from './index';
import { constants } from '@config';
import Store from '@store';
import { updateSliderValue } from '../ui/element-popupmenu/content/popupmenu-text-events';

export default class Text extends AbstractElement {
  constructor (parameters) {
    super();

    this.textContent = '';
    this.oldContent = '';
    this.firstDiffLinePosition = null;
    this.newLetters = null;
    this.cursorPosition = null;
    this.lineIndex = null;

    this.paragraph_spacing = 0;
    this.first_line_margin = 0;
    this.right_margin = 0;
    this.line_spacing = 0;
    this.word_spacing = 0;
    this.letter_spacing = 0;
    this.line_margin = 0;

    this.isLastLineEol = true;
    this.shouldRecalculateStyle = true;
    this.isTextOverflow = false;
    this.isContinuing = false;

    this.alignmentArray = [];
    this.triggeredArray = [];
    this.bulletArray = [];
    this.orderedArray = [];
    this.headingArray = [];
    this.orderedStyleArray = [];
    this.orderedNumberingStyleArray = [];
    this.orderedRegexArray = [];
    this.orderedStartArray = [];
    this.bulletStyleArray = [];

    this.customBulletSymbolArray = [];
    this.bulletFillArray = [];
    this.bulletFontSizeArray = [];
    this.bulletFontStyleArray = [];
    this.bulletHighlightArray = [];
    this.bulletWidthArray = [];
    this.bulletFontFamilyArray = [];
    this.bulletCustomFontIdArray = [];

    this.orderedFillArray = [];
    this.orderedFontSizeArray = [];
    this.orderedWidthArray = [];
    this.orderedFontFamilyArray = [];
    this.orderedCustomFontIdArray = [];
    this.orderedFontWeightArray = [];
    this.orderedFontStyleArray = [];
    this.orderedHighlightArray = [];

    this.strings = [];

    this.customFontIdHash = {};

    // [ { start, end, attribute, value }]
    this.styles = [];

    this.bullets = false;
    this.bulletWidth = 0;
    this.bulletFill = null;
    this.bulletFontSize = 0;

    this.ordered = false;
    this.orderedWidth = 0;
    this.orderedFill = null;
    this.orderedFontSize = 0;

    // attributes
    this.text_anchor = 'start';
    this.fill = '#000000';
    this.highlight = null;
    this.stroke = 'none';
    this.stroke_width = null;
    this.stroke_dasharray = null;
    this.font_family = 'Lato';
    this.custom_font_id = null;
    this.font_stretch = null;
    this.data_paragraph_style = null;
    this.data_meta = null;
    this.font_size = 22;
    this.text_decoration = null;
    this.font_weight = null;
    this.font_style = null;
    this.auto_adjustable = null;
    this.original_font_size = null;
    this.vertical_offset = null;
    this.columns = 1;
    this.columns_gap = 10;
    this.columns_balance = null;
    this.direction = null;
    this.isJapanese = false;
    this.isTextOverflowRendering = false;
    this.characterBBoxes = [];

    this.setValues(parameters);
  }

  setDOM (dom, shouldSkipGetChars) {
    if (!dom || !dom.matches('g.textarea')) return null;

    const that = this;
    this.dom = $(dom).find(/* old */'>text, >g.textGroup, >g.text'/* new */)[0] || {};

    const domSetter = new INKIVE.Text.TextDomSetter(that, dom);
    const textData = domSetter.getDataFromDom();
    this.setValues($.extend({}, textData));
    this.setSpanDOM(shouldSkipGetChars);

    return this;
  }

  setSpanDOM (shouldSkipGetChars) {
    const that = this;
    this.textContent = '';
    this.firstDiffLinePosition = null;
    this.newLetters = 0;
    this.cursorPosition = null;
    this.lineIndex = null;

    const tspans = [...that.dom.querySelectorAll(':scope > tspan, :scope > text')];
    const numOfLines = tspans.length;

    let orderedStart = null;

    tspans.forEach((tspan, tspanIndex) => {
      const startIndex = tspanIndex > 0 ? that.strings[tspanIndex - 1].endIndex : 0;

      const string = new INKIVE.Text.String({ startIndex }).setDOM(tspan);

      string.endIndex = string.startIndex + string.textContent.length;

      that.strings.push(string);

      if (string.styles.length) {
        that.styles = that.styles.concat(string.styles);
      }

      if (!string.isBlank) {
        that.textContent += string.textContent;
      }

      if (Number(string.bulletLevel)) {
        that.bullets = true;
      }

      if (Number(string.orderedLevel)) {
        that.ordered = true;

        // Backward compatibility for ordered start
        if (tspanIndex === 0 || (that.strings[tspanIndex - 1].isEol && !Number(that.strings[tspanIndex - 1].orderedLevel))) {
          orderedStart = Number(that.dom.dataset.orderedStart) || null;
        }
        string.orderedStart = string.orderedStart || orderedStart;
      }

      if (string.isEol) {
        that.textContent += '\n';
        if (orderedStart) orderedStart = null;
      }

      if (that.isTextOverflow && tspanIndex === numOfLines - 1) {
        that.isLastLineEol = string.isEol;
      }
    });

    if ($.inArray(this.textContent.charCodeAt(this.textContent.length - 1), [10, 32]) > -1) {
      this.textContent = this.textContent.slice(0, -1);
    }

    if (!shouldSkipGetChars) {
      this.characterBBoxes = this.getChars();
    }

    this.isJapanese = !!this.textContent.match(/[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/);

    if (that.auto_adjustable && _.contains(that.textContent, '\n')) {
      that.auto_adjustable = false;
    }
  }

  getStyles4Range (start, end) {
    const that = this;
    const retval = {};

    start = this.fakeCharIndexToReal(start);
    end = this.fakeCharIndexToReal(end);

    // Default
    $.each(PartialStylingAttributes, function (i, style) {
      const key = style.replace(/-/g, '_');
      retval[key] = that[key];
    });

    if (!INKIVE.Helpers.isInt(start) || !INKIVE.Helpers.isInt(end)) {
      console.warn('Text.getStyles4Range(): start and end should be integers');
      return retval;
    }

    if (that.styles.length > 0) {
      $.each(
        that.styles.concat().sort(function (a, b) { return (a.start > b.start) ? -1 : ((b.start > a.start) ? 1 : 0); }),
        function (i, style) {
          if (style.start <= start && style.end > start) {
            retval[style.attribute.replace(/-/g, '_')] = style.value;
          }
        });
    }

    return retval;
  }

  setTextCase (start, end, isUppercase) {
    if (!INKIVE.Helpers.isInt(start) || !INKIVE.Helpers.isInt(end)) {
      console.warn('Text.setTextCase(): start and end should be integers');
      return;
    }

    if (undefined === isUppercase) {
      console.warn('Text.setTextCase(): value mast be defined');
      return;
    }

    const isTextEditing = INKIVE.EditorFacade.canvas.getMode() === 'textedit';
    // set for all text
    if (start === end && start === 0 && !isTextEditing) {
      this.textContent = isUppercase ? this.textContent.toUpperCase() : this.textContent.toLocaleLowerCase();
    } else if (start !== end) {
      let str = this.textContent.substring(0, start);
      str += isUppercase
        ? this.textContent.substring(start, end).toUpperCase()
        : this.textContent.substring(start, end).toLocaleLowerCase();
      str += this.textContent.substring(end, this.textContent.length);

      this.textContent = str;
    }
  }

  makeNewStyle (start, end, attribute, value) {
    return {
      start,
      end,
      attribute,
      value
    };
  }

  removeUselessStyles () {
    this.styles = this.styles.filter(s => (!s.useless && s.start !== s.end));
  }

  removeDuplicatedStyles () {
    for (let i = 0; i < this.styles.length - 1; i++) {
      for (let j = i + 1; j < this.styles.length; j++) {
        const styleA = this.styles[i];
        const styleB = this.styles[j];
        const equal = styleA.attribute === styleB.attribute && styleA.value === styleB.value &&
          styleA.start === styleB.start && styleA.end === styleB.end;
        if (equal) {
          styleA.useless = true;
          break;
        }
      }
    }
    this.removeUselessStyles();
  }

  removeIncludedStyles (attribute, start, end) {
    this.styles.forEach(style => {
      style.useless = style.attribute === attribute && style.start >= start && style.end <= end;
    }
    );
    this.removeUselessStyles();
  }

  replaceOverlappedStyles (attribute, start, end, value) {
    start = this.fakeCharIndexToReal(start);
    end = this.fakeCharIndexToReal(end);

    this.detectSegment(attribute);
    const segments = new Set();

    this.styles.forEach(style => {
      style.overlapped = style.attribute === attribute &&
                      ((style.start >= start && style.start < end) ||
                       (style.end > start && style.end <= end) ||
                       (style.start <= start && style.end >= end));

      if (style.overlapped) {
        segments.add(style.segment);
      }
    });

    for (const segment of segments) {
      for (const style of this.styles) {
        if (style.segment === segment) {
          style.value = value;
        }
      }
    }
  }

  removeOverlappedStyles (attribute, start, end) {
    this.detectSegment(attribute);
    const segments = new Set();

    this.styles.forEach(style => {
      style.overlapped = style.attribute === attribute &&
                      ((style.start >= start && style.start < end) ||
                       (style.end > start && style.end <= end) ||
                       (style.start === start && style.end === end) ||
                       (style.start === end - 1 || style.end - 1 === start) ||
                       (style.start <= start && style.end >= end));

      if (style.overlapped) {
        segments.add(style.segment);
      }
    });

    for (const segment of segments) {
      for (const style of this.styles) {
        if (style.segment === segment) {
          style.overlapped = true;
        }
      }
    }

    this.styles = this.styles.filter(s => (!s.overlapped && s.start !== s.end));
  }

  detectSegment (attribute) {
    this.styles.sort((styleA, styleB) => styleA.start - styleB.start);
    let segmentId = 1;
    let currentSegmentValue = null;
    let lastStyle = null;

    for (let i = 0; i < this.styles.length; i++) {
      const currentStyle = this.styles[i];
      lastStyle = lastStyle || currentStyle[i - 1];

      if (currentStyle.attribute !== attribute) continue;

      // Check if a new segment should start
      if (currentStyle.value !== currentSegmentValue || (i > 0 && lastStyle.end !== currentStyle.start)) {
        currentSegmentValue = currentStyle.value;
        segmentId++;
      }

      // Assign segment ID
      currentStyle.segment = segmentId;
      lastStyle = currentStyle;
    }
  }

  sortStyles () {
    this.styles.sort((styleA, styleB) => styleA.start - styleB.start);
  }

  setLineStyling (start, end, attribute, value, listStyle) {
    const { startLineToStyle, lastLineToStyle } = INKIVE.Helpers.getStylingPart(start, end, this.dom);

    for (let lineIndex = startLineToStyle; lineIndex <= lastLineToStyle; lineIndex++) {
      if (attribute === 'text-anchor') {
        this.strings[lineIndex].textAnchor = value;
        this.strings[lineIndex].isButtonTriggered = true;
      } else if (attribute === 'bullets') {
        const paragraphIndex = this.strings.slice(0, lineIndex).filter(string => string.isEol).length;

        if (Number(value) === 0 && this.strings[lineIndex].bulletLevel > 1) {
          this.removeMarginByListLevel(paragraphIndex, this.strings[lineIndex].bulletLevel);
          this.strings[lineIndex].bulletLevel = 0;
        }

        this.strings[lineIndex].bulletLevel = this.strings[lineIndex].bulletLevel <= 1
          ? Number(value)
          : this.strings[lineIndex].bulletLevel;

        if (Number(value) && this.strings[lineIndex].orderedLevel) {
          this.strings[lineIndex].orderedLevel = 0;
          this.strings[lineIndex].orderedStyle = 0;
          this.strings[lineIndex].orderedStart = null;
          this.strings[lineIndex].orderedNumberingStyle = 0;
          this.strings[lineIndex].orderedRegex = '';
        }

        listStyle = listStyle || constants.text.bulletPoints.defaultStyleId;
        if (Number(value) && Number(listStyle)) {
          this.strings[lineIndex].bulletStyle = Number(listStyle);
        }

        this.strings[lineIndex].isButtonTriggered = true;
      } else if (attribute === 'ordered') {
        const paragraphIndex = this.strings.slice(0, lineIndex).filter(string => string.isEol).length;
        if (Number(value) === 0 && this.strings[lineIndex].orderedLevel > 1) {
          this.removeMarginByListLevel(paragraphIndex, this.strings[lineIndex].orderedLevel);
          this.strings[lineIndex].orderedLevel = 0;
        }

        this.strings[lineIndex].orderedLevel = this.strings[lineIndex].orderedLevel <= 1
          ? Number(value)
          : this.strings[lineIndex].orderedLevel;

        if (Number(value) && this.strings[lineIndex].bulletLevel) {
          this.strings[lineIndex].bulletLevel = 0;
          this.strings[lineIndex].bulletStyle = 0;
        }

        listStyle = listStyle || constants.text.orderedList.defaultStyleId;
        if (Number(value) && Number(listStyle)) {
          this.strings[lineIndex].orderedStyle = Number(listStyle);
          this.strings[lineIndex].orderedStart = null;
        }

        this.strings[lineIndex].isButtonTriggered = true;
      } else if (attribute === 'heading') {
        this.strings[lineIndex].heading = Number(value);
      }
    }

    return { startLineToStyle, lastLineToStyle };
  }

  getLineStyling (start, end) {
    const { startLineToStyle } = INKIVE.Helpers.getStylingPart(start, end, this.dom);

    return {
      textAnchor: this.strings[startLineToStyle].textAnchor,
      bulletLevel: this.strings[startLineToStyle].bulletLevel,
      isBlank: this.strings[startLineToStyle].isBlank,
      orderedLevel: this.strings[startLineToStyle].orderedLevel
    };
  }

  increaseListLevel (start, end, step = 1) {
    this.convertMarginToArray();
    const { startLineToStyle, lastLineToStyle } = INKIVE.Helpers.getStylingPart(start, end, this.dom);

    for (let lineIndex = startLineToStyle; lineIndex <= lastLineToStyle; lineIndex++) {
      const { orderedLevel, bulletLevel } = this.strings[lineIndex];

      if (!orderedLevel && !bulletLevel) continue;

      const isEndOfParagraph = this.strings[lineIndex].isEol || lineIndex === this.strings.length - 1;

      if (Number(orderedLevel) > 0) {
        const orderedStyle = this.strings[lineIndex]?.orderedStyle;
        const orderedStyleList = Store.getState().text.orderedList.styles;
        const maxLevel = orderedStyleList[orderedStyle]?.symbols?.length ?? constants.text.orderedList.maxLevel;
        const previousLevel = this.strings[lineIndex].orderedLevel;
        const currentLevel = Math.min((Number(orderedLevel) || 0) + step, maxLevel);

        this.strings[lineIndex].orderedLevel = currentLevel;
        this.strings[lineIndex].orderedLevel && bulletLevel && (this.strings[lineIndex].bulletLevel = 0);
        this.strings[lineIndex].isButtonTriggered = true;
        if (isEndOfParagraph && previousLevel !== currentLevel) {
          const paragraphIndex = this.strings.slice(0, lineIndex).filter(string => string.isEol).length;
          this.updateMarginByListLevel(paragraphIndex, step, lineIndex);
        }
      } else if (Number(bulletLevel) > 0) {
        const bulletStyle = this.strings[lineIndex]?.bulletStyle;
        const bulletStyleList = Store.getState().text.bulletList.styles;
        const maxLevel = bulletStyleList[bulletStyle]?.symbols?.length ?? constants.text.bulletPoints.maxLevel;
        const previousLevel = this.strings[lineIndex].bulletLevel;
        const currentLevel = Math.min((Number(bulletLevel) || 0) + step, maxLevel);

        this.strings[lineIndex].bulletLevel = currentLevel;
        this.strings[lineIndex].bulletLevel && orderedLevel && (this.strings[lineIndex].orderedLevel = 0);
        this.strings[lineIndex].isButtonTriggered = true;
        if (isEndOfParagraph && previousLevel !== currentLevel) {
          const paragraphIndex = this.strings.slice(0, lineIndex).filter(string => string.isEol).length;
          this.updateMarginByListLevel(paragraphIndex, step, lineIndex);
        }
      }
    }
  }

  updateMarginByListLevel (paragraphIndex, step, lineIndex) {
    const mainTextAnchor = this.strings[lineIndex].textAnchor || this.text_anchor;
    if (mainTextAnchor.includes('end')) return;

    const indent = Number(this.bulletFontSize) || Number(this.bulletFontSize) || Number(this.font_size) || constants.text.bulletPoints.marginIndent;
    const baseIndent = step > 0 ? indent : 0;
    this.line_margin[paragraphIndex] = this.line_margin[paragraphIndex]
      ? Math.max(this.line_margin[paragraphIndex] + step * indent, 0)
      : baseIndent;
    this.first_line_margin[paragraphIndex] = this.first_line_margin[paragraphIndex]
      ? Math.max(this.first_line_margin[paragraphIndex] + step * indent, 0)
      : baseIndent;

    updateSliderValue(this.first_line_margin[paragraphIndex], 'firstLineMargin');
    updateSliderValue(this.line_margin[paragraphIndex], 'lineMargin');
  }

  removeMarginByListLevel (paragraphIndex, previousLevel) {
    const indent = Number(this.bulletFontSize) || Number(this.orderedFontSize) || Number(this.font_size) || constants.text.bulletPoints.marginIndent;
    this.line_margin[paragraphIndex] = this.line_margin[paragraphIndex] !== (previousLevel - 1) * indent
      ? this.line_margin[paragraphIndex]
      : 0;
    this.first_line_margin[paragraphIndex] = this.first_line_margin[paragraphIndex] !== (previousLevel - 1) * indent
      ? this.first_line_margin[paragraphIndex]
      : 0;
  }

  convertMarginToArray () {
    const numOfEol = this.strings.filter(string => string.isEol).length;
    const numberOfParagraphs = this.strings[this.strings.length - 1].isEol ? numOfEol : numOfEol + 1;

    if (!Array.isArray(this.line_margin)) {
      this.line_margin = Array.from({ length: numberOfParagraphs }).fill(Number(this.line_margin) || 0);
    }

    if (!Array.isArray(this.first_line_margin)) {
      this.first_line_margin = Array.from({ length: numberOfParagraphs }).fill(Number(this.first_line_margin) || 0);
    }
  }

  decreaseListLevel (start, end, step = -1) {
    this.convertMarginToArray();
    const { startLineToStyle, lastLineToStyle } = INKIVE.Helpers.getStylingPart(start, end, this.dom);

    for (let lineIndex = startLineToStyle; lineIndex <= lastLineToStyle; lineIndex++) {
      const { orderedLevel, bulletLevel } = this.strings[lineIndex];

      if (!orderedLevel && !bulletLevel) continue;

      if (Number(orderedLevel) > 0) {
        this.strings[lineIndex].orderedLevel = Math.max((Number(orderedLevel) || 0) + step, constants.text.orderedList.minLevel);
        this.strings[lineIndex].orderedLevel && bulletLevel && (this.strings[lineIndex].bulletLevel = 0);
        this.strings[lineIndex].isButtonTriggered = true;
        if (this.strings[lineIndex].isEol || lineIndex === this.strings.length - 1) {
          const paragraphIndex = this.strings.slice(0, lineIndex).filter(string => string.isEol).length;
          Number(orderedLevel) > 1 && this.updateMarginByListLevel(paragraphIndex, step, lineIndex);
        }
      } else if (Number(bulletLevel) > 0) {
        this.strings[lineIndex].bulletLevel = Math.max((Number(bulletLevel) || 0) + step, constants.text.bulletPoints.minLevel);
        this.strings[lineIndex].bulletLevel && orderedLevel && (this.strings[lineIndex].orderedLevel = 0);
        this.strings[lineIndex].isButtonTriggered = true;
        if (this.strings[lineIndex].isEol || lineIndex === this.strings.length - 1) {
          const paragraphIndex = this.strings.slice(0, lineIndex).filter(string => string.isEol).length;
          Number(bulletLevel) > 1 && this.updateMarginByListLevel(paragraphIndex, step, lineIndex);
        }
      }
    }
  }

  removeLineStyling () {
    this.dom.querySelectorAll('text').forEach((line, lineIndex) => {
      this.strings[lineIndex].textAnchor = '';
    });
  }

  setPartialStyling (start, end, attribute, value, options = {}) {
    if (!INKIVE.Helpers.isInt(start) || !INKIVE.Helpers.isInt(end)) {
      console.warn('Text.setPartialStyling(): start and end should be integers');
      return;
    }

    if ($.inArray(attribute, PartialStylingAttributes) === -1) {
      console.warn('Text.setPartialStyling(): supported attributes are ' + PartialStylingAttributes.join(', '));
      return;
    }

    if (!value && !options.allowFalsyValue) {
      console.warn('Text.setPartialStyling(): value must be defined');
      return;
    }
    if (start === end && start === 0 && value === 'underline') {
      end = this.textContent.length;
    }
    const bulletMapping = {
      fill: 'bulletFill',
      'font-size': 'bulletFontSize',
      highlight: 'bulletHighlight',
      'font-style': 'bulletFontStyle'
    };

    const orderedMapping = {
      fill: 'orderedFill',
      highlight: 'orderedHighlight',
      'font-size': 'orderedFontSize',
      'font-weight': 'orderedFontWeight',
      'font-family': 'orderedFontFamily',
      'font-style': 'orderedFontStyle'
    };

    if (start === end && !!document.querySelector('#text_selectblock path')) {
      const { startLineToStyle, lastLineToStyle } = INKIVE.Helpers.getStylingPart(start, end, this.dom);
      for (let lineIndex = startLineToStyle; lineIndex <= lastLineToStyle; lineIndex++) {
        if (bulletMapping[attribute]) {
          this.strings[lineIndex][bulletMapping[attribute]] = value;
        }

        if (orderedMapping[attribute]) {
          this.strings[lineIndex][orderedMapping[attribute]] = value;
        }
      }

      !options.skipHistory && INKIVE.DesignFacade.trigger('text.update');

      return;
    }

    const realStart = this.fakeCharIndexToReal(start);
    const realEnd = this.fakeCharIndexToReal(end);

    this.removeIncludedStyles(attribute, realStart, realEnd);

    if (realStart === realEnd && realStart === 0) {
      const data = {};
      data[attribute.replace(/-/g, '_')] = value;
      this.setValues(data);
      this.styles.forEach(style => { style.useless = style.attribute === attribute; });
      this.removeUselessStyles();

      !options.skipHistory && INKIVE.DesignFacade.trigger('text.update');

      return;
    }

    if (options.shouldRemoveOverlappedStyles) {
      this.removeOverlappedStyles(attribute, realStart, realEnd);
    }

    const me = this;

    function divideStyle (style, point) {
      const styleLeft = me.makeNewStyle(style.start, point, style.attribute, style.value);
      const styleRight = me.makeNewStyle(point, style.end, style.attribute, style.value);
      return [styleLeft, styleRight];
    }

    function checkIntersection (point) {
      const newStyles = [];
      for (let i = 0; i < me.styles.length; i++) {
        const style = me.styles[i];
        if (point > style.start && point < style.end) {
          const [styleLeft, styleRight] = divideStyle(style, point);
          newStyles.push(styleLeft);
          newStyles.push(styleRight);
          style.useless = true;
        }
      }
      me.styles = me.styles.concat(newStyles);
      me.removeUselessStyles();
      me.sortStyles();
    }

    checkIntersection(realStart);
    checkIntersection(realEnd);

    this.removeIncludedStyles(attribute, realStart, realEnd);

    let breakPoints = [];
    this.styles.forEach(style => {
      breakPoints.push(style.start);
      breakPoints.push(style.end);
    });
    breakPoints = [...new Set(breakPoints)];
    breakPoints.sort((a, b) => a - b);

    const newStyles = [];

    let s = realStart;
    breakPoints.forEach(breakPoint => {
      if (breakPoint > s && breakPoint < realEnd) {
        newStyles.push(me.makeNewStyle(s, breakPoint, attribute, value));
        s = breakPoint;
      }
    });
    newStyles.push(me.makeNewStyle(s, realEnd, attribute, value));
    this.styles = this.styles.concat(newStyles);
    this.removeDuplicatedStyles();
    this.sortStyles();

    !options.skipHistory && INKIVE.DesignFacade.trigger('text.update');
  }

  getPartialStyling (start, end, attribute) {
    const realStart = this.fakeCharIndexToReal(start);
    const matchStart = this.styles.find(style => style.attribute === attribute && style.start <= realStart && style.end > realStart);

    return matchStart ? matchStart?.value : undefined;
  }

  setMultiplePartialStyling (start, end, attributes) {
    const attributeEntries = Object.entries(attributes);

    attributeEntries.forEach(([attribute, value], index) => {
      this.setPartialStyling(start, end, attribute, value, {
        skipHistory: true
      });
    });
  }

  isRangeOverlapped (start, end, attribute) {
    const realEnd = this.fakeCharIndexToReal(end);
    const realStart = this.fakeCharIndexToReal(start);
    let overlapped = false;
    this.styles.forEach(style => {
      if (style.attribute === attribute && style.start < realEnd && style.end > realStart) {
        overlapped = true;
        return overlapped;
      }
    });
    return overlapped;
  }

  isSegmentSelected (start, end, attribute) {
    this.detectSegment(attribute);

    const realEnd = this.fakeCharIndexToReal(end);
    const realStart = this.fakeCharIndexToReal(start);
    const matchStart = this.styles.find(style => style.attribute === attribute && style.start === realStart);
    const matchEnd = this.styles.find(style => style.attribute === attribute && style.end === realEnd);

    if (matchStart && this.styles.find(style => style.attribute === attribute && style.start < matchStart.start && style.segment === matchStart.segment)) {
      this.cleanSegmentAttribute(attribute);
      return false;
    }

    if (matchEnd && this.styles.find(style => style.attribute === attribute && style.end > matchEnd.end && style.segment === matchEnd.segment)) {
      this.cleanSegmentAttribute(attribute);
      return false;
    }

    this.cleanSegmentAttribute(attribute);
    return matchStart && matchEnd && matchStart.segment === matchEnd.segment;
  }

  cleanSegmentAttribute (attribute) {
    for (const style of this.styles) {
      if (style.attribute === attribute && style.segment) {
        delete style.segment;
      }
    }
  }

  removePartialStyling (start, end) {
    this.styles.forEach(style => {
      const outsideOfRange = (style.start <= start && style.end <= start) || (style.start >= end && style.end >= end);
      style.useless = !outsideOfRange;
    });
    this.removeUselessStyles();
  }

  removeSpecificPartialStyling (start, end, attribute, value, options = {}) {
    if (options.shouldRemoveOverlappedStyles) {
      this.removeOverlappedStyles(attribute, this.fakeCharIndexToReal(start), this.fakeCharIndexToReal(end));
    }

    const parentStyle = TextStylingService.mapTextToStyle(this);
    const spreadStyle = TextStylingService.spreadStyles(this.styles, this.textContent, parentStyle);

    if (!spreadStyle[attribute]) return;
    spreadStyle[attribute] = TextStylingService.replaceItemsInArray(spreadStyle[attribute], start, end, undefined, value);

    const narrowedStyles = TextStylingService.narrowStyles(spreadStyle);
    const splittedStyles = TextStylingService.splitStyles(narrowedStyles);
    this.styles = TextStylingService.removeRedundantStyles(splittedStyles, parentStyle);
  }

  getBBox () {
    return this.dom.getBBox();
  }

  getCRect () {
    return $.extend({}, this.dom.getBoundingClientRect());
  }

  getChars () {
    const that = this;

    // Needful element to get real char indices
    that.fakeCharsIndices = [];

    let characterBBoxes = [];

    let newIndex = 0;

    $.each(this.strings, function (line, string) {
      characterBBoxes = characterBBoxes.concat(string.getChars(newIndex, line + 1, that.font_size, that.styles));
      newIndex = string.lastIndex + 1;

      if (string.containsFakeChar) {
        that.fakeCharsIndices.push(characterBBoxes.length - 1);
      }
    });

    return characterBBoxes;
  }

  fakeCharIndexToReal (index) {
    let retval = index;

    if (this.fakeCharsIndices && this.fakeCharsIndices.length > 0) {
      $.each(this.fakeCharsIndices, function (i, fake) {
        if (fake < index) {
          retval--;
        } else {
          return false;
        }
      });
    }

    return retval;
  }

  realCharIndexToFake (index) {
    const fakeCharsIndices = this.fakeCharsIndices;
    if (!fakeCharsIndices || !fakeCharsIndices.length) return index;

    let fakeIndex = index;
    for (let i = 0; i < fakeCharsIndices.length; i++) {
      if (fakeCharsIndices[i] < fakeIndex) fakeIndex++;
      else break;
    }

    return fakeIndex;
  }

  getRenderLineSpacing (lineIndex) {
    let lineSpacing = this.line_spacing;

    if (Array.isArray(lineSpacing)) {
      const paragraphIndex = INKIVE.Text.Helpers.getParagraphIndex(this, lineIndex);
      lineSpacing = this.line_spacing[paragraphIndex];
      if (isNaN(lineSpacing) || typeof lineSpacing === 'undefined') {
        lineSpacing = this.line_spacing[this.line_spacing.length - 1];
      }
    }

    return lineSpacing;
  }

  isTextSizeAutoAdjustable (parent) {
    const isTableText = parent.dom.parentElement && parent.dom.parentElement.classList.contains('table-cell');
    if (isTableText) return false;

    let isAutoAdjustable = parent.isSubelement();

    if (parent.dom?.closest?.('.group') !== null) {
      isAutoAdjustable = false;
    }

    return parent.text.auto_adjustable || isAutoAdjustable;
  }

  renderText (canvas, parent, redrawing = false) {
    const that = this;

    const textRenderer = new INKIVE.Text.TextRenderer(that, canvas, parent).initialize();
    textRenderer.renderText(canvas, parent, redrawing);
  }

  getLineFontSize (startIndex, endIndex) {
    const that = this;
    let lineFontSize = 0;

    const fontSizeStyles = that.styles.filter(style => style.attribute === 'font-size' && style.end >= startIndex && style.start <= endIndex);
    if (!fontSizeStyles.length) return Math.max(lineFontSize, that.bulletFontSize, that.orderedFontSize);

    const fillFontSizeStyles = TextStylingService.insertFontSizeStyle(0, that.textContent, fontSizeStyles, that.font_size);
    // Get the largest font size in the line
    for (let i = 0; i < fillFontSizeStyles.length; i++) {
      const style = fillFontSizeStyles[i];
      const leftSide = startIndex >= style.end && endIndex >= style.end;
      const rightSide = startIndex <= style.start && endIndex <= style.start;
      const intersectionMode = !(leftSide || rightSide);
      if (!intersectionMode) continue;

      if (style.value > lineFontSize) {
        lineFontSize = style.value;
      }
    }

    return Math.max(lineFontSize, that.bulletFontSize, that.orderedFontSize);
  }

  adjustFontSize (canvas, that, parent, newFontSize) {
    const dy = (that.font_size - newFontSize) / 2;

    that.font_size = newFontSize;
    that.dom.setAttribute('font-size', that.font_size);
    parent.moveTextByY(canvas, dy);
  }

  render (canvas, parent) {
    const that = this;

    if (!that.dom || !that.dom.hasChildNodes()) {
      that.dom = canvas.addSvgElementFromJson({
        element: 'g',
        curStyles: false,
        attr: {}
      }, parent.dom);

      const cls = that.getTextClass();
      that.getTextData();

      that.resetFontDecoration();

      that.dom.setAttribute('class', cls);

      that.dom.setAttribute('fill', that.fill);
      that.highlight && that.dom.setAttribute('highlight', that.highlight);
      that.dom.setAttribute('stroke', that.stroke);
      that.dom.setAttribute('font-family', that.font_family);
      that.dom.setAttribute('font-size', that.font_size);
      that.dom.setAttribute('text-anchor', that.text_anchor);
      that.stroke_width === null || that.dom.setAttribute('stroke-width', that.stroke_width);

      if (that.stroke_dasharray) {
        that.dom.setAttribute('stroke-dasharray', that.stroke_dasharray);
      }

      const fontData = INKIVE.FontsFactory.get(that.font_family);
      if (fontData) that.custom_font_id = fontData.customId;

      that.custom_font_id && that.dom.setAttribute('custom-font-id', that.custom_font_id);
      that.font_stretch && that.dom.setAttribute('font-stretch', that.font_stretch);
      that.data_paragraph_style && that.dom.setAttribute('data-paragraph-style', that.data_paragraph_style);
      that.data_meta && that.dom.setAttribute('data-meta', that.data_meta);
      that.text_decoration && that.dom.setAttribute('text-decoration', that.text_decoration);
      that.font_weight && that.dom.setAttribute('font-weight', that.font_weight);
      that.font_style && that.dom.setAttribute('font-style', that.font_style);
      that.vertical_offset && that.dom.setAttribute('data-vertical-offset', that.vertical_offset);
      that.auto_adjustable && $(that.dom).addClass('auto-adjustable');
      that.original_font_size && that.dom.setAttribute('data-original-font-size', that.original_font_size);
      that.columns > 1 && $(that.dom).addClass('columns-' + this.columns);

      if (that.letter_spacing >= 0.5) {
        that.dom.setAttribute('font-variant', 'no-common-ligatures');
      }
    }

    that.direction === 'rtl' && that.dom.setAttribute('direction', 'rtl');

    if (that.styles.length && that.shouldRecalculateStyle) {
      if (that.cursorPosition !== null) {
        const parentStyle = TextStylingService.mapTextToStyle(that);
        that.styles = TextStylingService.shiftPartialStyling(that.oldContent, that.textContent, that.cursorPosition, that.newLetters, that.styles, parentStyle);
      } else {
        this.checkGlobalPartialStyles();
        // this.removeEmptyLineStyles();
        this.recalculatePartialStyles();
      }
    }

    if (this.columns > 1) {
      const textColumn = new INKIVE.Text.TextColumn(that, canvas, parent);
      textColumn.renderText(canvas, parent);
    } else {
      // const redraw = that.renderText(canvas, parent, false);
      that.renderText(canvas, parent);
    }

    return that.dom;
  }

  getTextClass () {
    const that = this;

    let cls = 'text';

    if (that.letter_spacing && !Array.isArray(that.letter_spacing)) cls += ' letter-spacing-' + that.letter_spacing;
    if (that.word_spacing && !Array.isArray(that.word_spacing)) cls += ' word-spacing-' + that.word_spacing;

    if (that.line_spacing && !Array.isArray(that.line_spacing)) cls += ' line-spacing-' + that.line_spacing;
    if (that.line_margin && !Array.isArray(that.line_margin)) cls += ' line-margin-' + that.line_margin;
    if (that.paragraph_spacing && !Array.isArray(that.paragraph_spacing)) cls += ' paragraph-spacing-' + that.paragraph_spacing;
    if (that.first_line_margin && !Array.isArray(that.first_line_margin)) cls += ' first-line-margin-' + that.first_line_margin;
    if (that.right_margin && !Array.isArray(that.right_margin)) cls += ' right-margin-' + that.right_margin;

    return cls;
  }

  getTextData () {
    const that = this;

    if (that.line_spacing && Array.isArray(that.line_spacing)) that.dom.setAttribute('data-dy', that.line_spacing.join(' '));
    if (that.line_margin && Array.isArray(that.line_margin)) that.dom.setAttribute('data-margin', that.line_margin.join(' '));
    if (that.paragraph_spacing && Array.isArray(that.paragraph_spacing)) that.dom.setAttribute('data-paragraph-dy', that.paragraph_spacing.join(' '));
    if (that.first_line_margin && Array.isArray(that.first_line_margin)) that.dom.setAttribute('data-first-line-margin', that.first_line_margin.join(' '));
    if (that.right_margin && Array.isArray(that.right_margin)) that.dom.setAttribute('data-right-margin', that.right_margin.join(' '));
  }

  getLongestLineWidth () {
    let width = 0;
    const textContent = this.textContent.split('\n');
    const longestLine = _.find(this.getFullLinesWithIndex(), function (elem) {
      return elem.content === _.max(textContent, function (elem) {
        return elem.length;
      });
    });

    _.each(this.strings, function (string, index) {
      if (_.contains(longestLine.index, index)) {
        width += svgedit.utilities.getBBox(string.dom).width;
      }
    });

    return width;
  }

  getFullLinesWithIndex () {
    const fullLines = [];
    let line = {
      content: '',
      index: []
    };

    _.each(this.strings, function (string, index) {
      line.content += string.textContent;
      line.index.push(index);

      if (string.isEol) {
        fullLines.push(line);
        line = {
          content: '',
          index: []
        };
      }
    });

    return fullLines;
  }

  recalculatePartialStyles () {
    const that = this;
    const newLineBreaks = getNewLineBreaks();
    const newLetters = that.newLetters < -1 ? 0 : that.newLetters;
    const cursorPosition = that.cursorPosition - (that.newLetters >= 0 ? newLetters : 0);
    const difference = INKIVE.Tool.calculateStringContentDifference(that.oldContent, that.textContent);

    if (!_.isNumber(cursorPosition) && !difference.position) return;

    that.styles = cursorPosition >= 0 && that.newLetters >= 0
      ? calculateNewStyles(cursorPosition)
      : calculateNewStyles(difference.position, difference.added, difference.removed);

    function getNewLineBreaks () {
      let diffText;

      const difference = INKIVE.Tool.calculateStringContentDifference(that.oldContent, that.textContent);

      if (difference.added) {
        diffText = that.textContent.substr(difference.position, difference.added);
      } else {
        diffText = that.oldContent.substr(difference.position, difference.removed);
      }

      return diffText.match(/\n/g) ? 1 : 0;
    }

    function getStyleAlignment (s, e, style) {
      // [1---1][2---2][s-----------------e][6---6][7---7]
      //              [3---3][4---4][5---5]
      //              [8----------------------8]
      //         [9----------------------9]
      //              [10---------------10]
      //          [11---11]
      //                              [12---12]
      //      [13-------------------------13]

      // 1
      if (style.start < s && style.end < s) {
        return 1;
      }
      // 2
      if (style.start < s && style.end === s) {
        return 2;
      }
      // 3
      if (style.start === s && style.end < e) {
        return 3;
      }
      // 4
      if (style.start > s && style.end < e) {
        return 4;
      }
      // 5
      if (style.start > s && style.end === e) {
        return 5;
      }
      // 6
      if (style.start === e) {
        return 6;
      }
      // 7
      if (style.start > e) {
        return 7;
      }
      // 8
      if (style.start === s && style.end > e) {
        return 8;
      }
      // 9
      if (style.start < s && style.end === e) {
        return 9;
      }
      // 10
      if (style.start === s && style.end === e) {
        return 10;
      }
      // 11
      if (style.start < s && style.end > s && style.end < e) {
        return 11;
      }
      // 12
      if (style.start > s && style.start < e && style.end > e) {
        return 12;
      }
      // 13
      if (style.start < s && style.end > e) {
        return 13;
      }
      return -1;
    }

    function changeStyleForInsertion (s, e, delta, style, styleAlignment) {
      function handleEol (s, e, delta, oldText, newText) {
        const insertToStart = s === 0;
        const isStartWithEol = oldText[s] === '\n';
        const isSingleInsertion = delta <= 1;
        const multipleInsertionEolShift = handleMultipleInsertions(s, e, newText);
        const isSingleEolInserted =
          newText[s - 1] === '\n' &&
          newText[s + 1] === '\n' &&
          newText[s] !== '\n';
        const isInsertedBetweenEols =
          newText.slice(s, e).includes('\n') &&
          (newText[s] !== '\n' || newText[s - 1] !== '\n');

        if (insertToStart) return isStartWithEol ? -1 : 0;
        if (isSingleInsertion) return isSingleEolInserted ? -1 : 0;
        if (isInsertedBetweenEols) return multipleInsertionEolShift !== 0 ? multipleInsertionEolShift : -1;
        return 0;

        function handleMultipleInsertions (s, e, newText) {
          let count = 0;
          for (let i = s; i < e; i++) {
            const isEol = newText[i] === '\n' && newText[i + 1] !== '\n';
            if (isEol) count--;
          }
          return count;
        }
      }

      // Did we insert a fake character?
      let insertedFakeCharacter = delta === 1 && newLineBreaks > 0 && that.textContent[s] === '\n' && (that.textContent[s - 1] === '\n' || that.textContent[s + 1] === '\n');
      // We may insert a fake character if cursor position is zero
      insertedFakeCharacter = insertedFakeCharacter || (newLineBreaks > 0 && s === 0);
      // If we are adding '\n' without creating a fake character, there is nothing to change
      if (newLineBreaks > 0 && !insertedFakeCharacter && delta === 1) return style;

      const eolShift = handleEol(s, e, delta, that.oldContent, that.textContent);
      delta += eolShift;

      const newStyle = { ...style };
      switch (styleAlignment) {
        case 1:
          // Ignore
          break;
        case 2:
          // Expand the style
          newStyle.end += delta;
          break;
        case 3:
          // Offset the style
          if (s > 0) newStyle.start += delta;
          newStyle.end += delta;
          break;
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
          // Offset the style
          newStyle.start += delta;
          newStyle.end += delta;
          break;
        case 9:
          // Expand the style
          newStyle.end += delta;
          break;
        case 10:
          // Offset the style (offset the starting point only if it is not at the beginning)
          if (s > 0) newStyle.start += delta;
          newStyle.end += delta;
          break;
        case 11:
          // Expand the style
          newStyle.end += delta;
          break;
        case 12:
          // Offset the style
          newStyle.start += delta;
          newStyle.end += delta;
          break;
        case 13:
          // Expand the style
          newStyle.end += delta;
          break;
      }
      return newStyle;
    }

    function changeStyleForDeletion (s, e, delta, style, styleAlignment) {
      function countConsecutiveNewLineFeeds (text) {
        if (!text || text.length === 0) return 0;
        let result = 0;
        let previous = text[0];
        for (let i = 1; i < text.length; i++) {
          const current = text[i];
          if (previous === '\n' && current === '\n') {
            result++;
          }
          previous = current;
        }
        return result;
      }

      function handleEol (s, e, delta, oldText, newText) {
        const noChanged = !oldText || oldText.length === 0;
        const isBegin = s === 0;
        const isEolLast = oldText[e] === '\n';
        const isEolMiddle = oldText.slice(s, e - 1).includes('\n');
        const isEol = oldText.slice(s, e).includes('\n');
        const isSingleDeletion = delta >= -1;
        const eolShit = handleMultipleDeletion(s, e, oldText);
        if (noChanged) return 0;
        if (isBegin && isEolLast && !isEolMiddle) return 1;
        if (isSingleDeletion) return 0;
        if (isEol) return eolShit;
        return 0;

        function handleMultipleDeletion (s, e, oldText) {
          let count = 0;
          for (let i = s; i < e; i++) {
            if (oldText[i] === '\n') {
              count++;
            }
          }
          if (s === 0 && oldText[e] === '\n') count++;
          return count;
        }
      }

      // Did we remove a fake character?
      let removedFakeCharacter = newLineBreaks > 0 && that.oldContent[s] === '\n' && (that.oldContent[s - 1] === '\n' || that.oldContent[s + 1] === '\n');
      // We may remove a fake character if cursor position is zero
      removedFakeCharacter = removedFakeCharacter || (newLineBreaks > 0 && s === 0);
      // If we are removing '\n' without deleting a fake character, there is nothing to change
      if (newLineBreaks > 0 && !removedFakeCharacter && delta === -1) return style;
      // Deleting part of text can leave a fake character behind
      const newLinesTextContent = countConsecutiveNewLineFeeds(that.textContent);
      const newLinesOldContent = countConsecutiveNewLineFeeds(that.oldContent);
      const newLineDelta = newLinesTextContent - newLinesOldContent;
      const eolShift = handleEol(s, e, delta, that.oldContent, that.textContent);
      if (newLineDelta > 0) delta += newLineDelta;

      delta += eolShift;

      const newStyle = { ...style };
      switch (styleAlignment) {
        case 1:
        case 2:
          // Ignore
          break;
        case 3:
        case 4:
        case 5:
          // Discard the style
          newStyle.start = 0;
          newStyle.end = 0;
          break;
        case 6:
        case 7:
          // Offset the style
          newStyle.start += delta;
          newStyle.end += delta;
          break;
        case 8:
        case 9:
          // Offset the end point
          newStyle.end += (s - e);
          break;
        case 10:
          // Discard the style
          newStyle.start = 0;
          newStyle.end = 0;
          break;
        case 11:
          newStyle.end += (s - style.end);
          break;
        case 12:
          newStyle.start += (s - style.start);
          newStyle.end += delta;
          break;
        case 13:
          newStyle.end += delta;
          break;
      }
      return newStyle;
    }

    function calculateNewStyles (position, added = 0, removed = 0) {
      const newStyles = [];
      const s = position;
      const e = position + Math.abs(that.newLetters);
      const delta = that.newLetters;

      _.any(that.strings, function (string) {
        _.each(string.getStringStyles(that.styles), function (style) {
          if (style.attribute) {
            style.start += string.startIndex;
            style.end += string.startIndex;

            const styleAlignment = getStyleAlignment(that.fakeCharIndexToReal(s), that.fakeCharIndexToReal(e), style);
            const newStyle = that.newLetters >= 0
              ? changeStyleForInsertion(s, e, delta, style, styleAlignment)
              : changeStyleForDeletion(s, e, delta, style, styleAlignment);
            const maxStartIndex = (_.max(newStyles, 'start') || {}).start || 0;
            const isValidStylePosition =
              maxStartIndex <= newStyle.start &&
              newStyle.end > newStyle.start;
            const isToKeepStyle =
              newStyle.end <= position ||
              newStyle.start >= position + added ||
              (newStyle.end <= position + added && newStyle.start === position);

            if (added && removed) {
              isValidStylePosition && isToKeepStyle && newStyles.push(newStyle);
            } else {
              isValidStylePosition && newStyles.push(newStyle);
            }
          }
        });
      });

      return newStyles;
    }
  }

  getStringInPosition (position) {
    if (!this.characterBBoxes?.length) {
      return this.strings[0];
    }

    if (position < 0) {
      position = 0;
    }

    let char = this.characterBBoxes[position];

    if (char && !char.line) {
      char = this.characterBBoxes[position - 1];
    }

    const linePosition = char ? char.line - 1 : 0;

    return this.strings[linePosition];
  }

  removeEmptyLineStyles () {
    const that = this;

    const removedBlankLineStyles = [];
    _.each(that.styles, function (style) {
      if (style.end - style.start > 1 || !that.getStringInPosition(style.end).isBlank) {
        removedBlankLineStyles.push(style);
      }
    });
    that.styles = removedBlankLineStyles;
  }

  checkGlobalPartialStyles () {
    const that = this;

    if (!that.styles.length) {
      return;
    }

    const styleGroups = _.groupBy(that.styles, function (styleGroup) {
      return styleGroup.attribute + '::' + styleGroup.value;
    });

    _.each(styleGroups, function (styleGroup, key) {
      let isGlobal = true;
      let isFullLineStyle;
      const styleAttribute = key.split('::')[0];
      const styleValue = key.split('::')[1];

      _.each(that.strings, function (string) {
        if (!string.isBlank) {
          const stringStyleGroup = [styleGroup, string.styles].reduce((a, b) => a.filter(c => b.includes(c)));
          const styleStart = _.min(stringStyleGroup, function (st) { return st.start; }).start;
          let styleEnd = _.min(stringStyleGroup, function (st) { return st.end; }).end;

          _.each(stringStyleGroup, function (style) {
            if (style.start === styleEnd) {
              styleEnd = style.end;
            }
          });

          isFullLineStyle = string.startIndex === styleStart && string.endIndex === styleEnd;
        }

        if (!isFullLineStyle) {
          isGlobal = false;
          return true;
        }
      });

      if (isGlobal && styleAttribute !== 'text-decoration') {
        if (!_.isUndefined(that[styleAttribute]) || !_.isUndefined(that[styleAttribute.replace(/-/g, '_')])) {
          that.styles = _.reject(that.styles, function (style) {
            return style.attribute === styleAttribute && style.value === styleValue;
          });
          const style = {};
          style[styleAttribute] = styleValue;
          that.setValues(style);
          that.dom.setAttribute(styleAttribute, styleValue);
          if (styleAttribute === 'font-size') that.font_size = Number(styleValue);
          if (styleAttribute === 'font-weight') that.font_weight = styleValue;
          if (styleAttribute === 'font-family') that.font_family = styleValue;
        }
      }
    });
  }

  addHighlightRects (canvas) {
    const isSafariBrowser = isSafari();
    const applyHighlight = function (node, color) {
      if (node.classList.contains('blank')) return;

      let bbox = {};
      if (isSafariBrowser) {
        const firstCharBBox = node.getExtentOfChar(0);
        const computedStyle = getComputedStyle(node);

        bbox.width = INKIVE.Text.Helpers.getLineBBox({
          font_size: parseFloat(computedStyle.fontSize),
          font_family: computedStyle.fontFamily,
          font_weight: computedStyle.fontWeight,
          styles: []
        }, 0, node.textContent).width;

        bbox.x = firstCharBBox.x;
        bbox.y = firstCharBBox.y;
        bbox.height = firstCharBBox.height;
      } else {
        bbox = node.getBBox();
      }

      color = color || node.getAttribute('highlight');

      const height = node.getAttribute('font-size') || this.font_size;
      const y = bbox.y + (bbox.height - parseFloat(height)) / 2;

      const rect = canvas.addSvgElementFromJson({
        element: 'rect',
        curStyles: false,
        attr: {
          x: bbox.x,
          y,
          width: bbox.width + 1,
          height,
          fill: color
        }
      }, this.dom);

      rect.classList.add('highlight-rect');
      this.dom.before(rect);
    };

    this.dom.parentElement.querySelectorAll('rect.highlight-rect').forEach((r) => r.remove());

    const textareaHighlight = this.dom.getAttribute('highlight');
    const highlighted = this.dom.querySelectorAll('[highlight]');

    textareaHighlight && this.dom.querySelectorAll('text').forEach((text) => {
      applyHighlight.call(this, text, textareaHighlight);
    });

    highlighted.length && highlighted.forEach((tspan) => applyHighlight.call(this, tspan));
  }
}
